import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash-es';
import { AdminSettingsService } from '../services/admin.settings.service';
import { UiService } from '../../../services/core.ui.service';
import { GfTitleService } from '../../../services/core.title.service';

@Component({
    selector: 'adminScmView',
    template: require('./admin.scm.component.html')
})
export class SiteAdminScmComponent implements OnInit {

    protected accessOptions = {
        'Off': 'off',
        'HTTP': 'http',
        'SSH': 'ssh'
    };

    protected cvsAccessOptions = {
        'Off': 'off',
        'SSH': 'ssh'
    };

    protected offYesNo = {
        'Off': 'off',
        'Yes': 'yes',
        'No': 'no'
    };

    protected useMainChoices = {
        'master' : 'no',
        'main' : 'yes'
    };

    protected setScmAccess;
    protected setGit;
    protected setCvs;
    protected setSvn;
    protected setTag;
    protected setIndexing;
    protected setUseMain;
    protected settings;
    protected saving = false;

    protected yesNo = { 'Yes': 'yes', 'No': 'no' };

    constructor(
        private $window: Window, 
        private adminSettingsService: AdminSettingsService, 
        private uiService: UiService,
        private titleService: GfTitleService,
    ) { }
    
    ngOnInit() {
        this.setScmAccess = _.partial(this.setFieldSetting, 'allowChangeScmAccess');
        this.setGit = _.partial(this.setFieldSetting, 'gitSetting');
        this.setCvs = _.partial(this.setFieldSetting, 'cvsSetting');
        this.setSvn = _.partial(this.setFieldSetting, 'svnSetting');
        this.setTag = _.partial(this.setFieldSetting, 'tagSetting');
        this.setIndexing = _.partial(this.setFieldSetting, 'indexSetting');
        this.setUseMain = _.partial(this.setFieldSetting, 'gitUseMain');
    
        this.titleService.setTitle('Site Admin', 'SCM Repositories');

        this.adminSettingsService.getScmConfig().then(
            (response) => {
                this.settings = this.adminSettingsService.ui.settingsToUiFlags(response);
            },
            (error) => {
                console.log(error);
                this.uiService.message.showWarning("Sorry, could not retrieve the site SCM settings", "Site SCM Settings");
            }
        );
    };

    saveSettings = () => {
        this.saving = true;
        var settings = this.adminSettingsService.ui.uiFlagsToSettings(this.settings);
        this.adminSettingsService.saveScmConfig(settings).then(
            () => {
                this.uiService.message.showSuccess("Site SCM settings were updated successfully", "Site SCM Settings");
            },
            (error) => {
                console.log(error);
                this.uiService.message.showError("Sorry, could not save the site SCM settings", "Site SCM Settings");
            }
        ).finally(() => { this.saving = false; });
    };

    setFieldSetting(fieldName, value) {
        if (value == undefined || value == _.get(this.settings, fieldName)) return false;
        this.settings[fieldName] = value;
    };
}